export const LOGIN_ROUTE = '/login'
export const START_PAGE_ROUTE = '/'
export const REMINDERS_PAGE_ROUTE = '/reminders'
export const ADDRESSES_PAGE_ROUTE = '/addresses'
export const OVERVIEW_PAGE_ROUTE = '/overview'
